import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import SwiperCore, {
  EffectCoverflow,
  Pagination,
  Navigation,
  Autoplay,
} from "swiper";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
SwiperCore.use([EffectCoverflow, Pagination, Navigation, Autoplay]);

const sliderDiv = <div className=" relative sli-rel-div h-[250px] md:h-[300px] w-full mt-10">
  <Skeleton highlightColor="red" enableAnimation="true"  className=" relative border-0 skeleton-img"  height={250} />
  <div className="absolute w-full h-[250px] top-0 left-0 flex items-center justify-center text-slide-inside">
    <div className="text-center">
      <h4 className="h4-copied h4-copid-skelon mt-[35px!important]">
        <Skeleton width="100%" height={25} highlightColor="gray"/>
      </h4>
      <h1 className="mb-1 px-2 mt-[65px!important]">
        <Skeleton  height={20} highlightColor="gray"/>
      </h1>
      <h1 className="px-2 mb-1">
        <Skeleton height={20} highlightColor="gray"/>
      </h1>
      <div className="md:flex md:mt-6">
        <button className="btn-details-slide rounded-md text-[white] px-4 py-[2px] ">
          <Skeleton  width={100} height={25} highlightColor="gray"/>
        </button>
        <button className="btn-details-slide rounded-md text-[white] px-4 py-[2px]">
          <Skeleton width={100} height={25} highlightColor="gray"/>
        </button>
      </div>
    </div>
  </div>
</div>
;

const SlideLoadingSkeleton = () => {
  return (
    <SkeletonTheme baseColor="black"  highlightColor="white" duration={2.5} enableAnimation={true}>
      <section className="slider-bg pb-[40px!important]">
        <h1 className="text-white text-[20px] text-center title-slide mb-1">
          Most Searched Drinks
        </h1>
        <div className="w-[100px] h-1 bg-[#ffffff] mx-auto mb-2 rounded-lg"></div>
        <Swiper
          effect={"coverflow"}
          grabCursor={true}
          centeredSlides={true}
          slidesPerView={"auto"}
          spaceBetween={30}
          loop={true}
          loopfillgroupwithblank="true"
          navigation
          autoplay={{ delay: 5000 }}
          coverflowEffect={{
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: true,
          }}
          modules={[EffectCoverflow]}
          className="mySwiper"
          breakpoints={{
            350: {
              slidesPerView: 2,
              spaceBetween: 0,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 30,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 40,
            },
          }}
        >
          <SwiperSlide>{sliderDiv}</SwiperSlide>
          <SwiperSlide>{sliderDiv}</SwiperSlide>
          <SwiperSlide>{sliderDiv}</SwiperSlide>
          <SwiperSlide>{sliderDiv}</SwiperSlide>
          <SwiperSlide>{sliderDiv}</SwiperSlide>
          <SwiperSlide>{sliderDiv}</SwiperSlide>
        </Swiper>
      </section>
    </SkeletonTheme>
  );
};

export default SlideLoadingSkeleton;
